import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a50fd8ec&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a50fd8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50fd8ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a50fd8ec')) {
      api.createRecord('a50fd8ec', component.options)
    } else {
      api.reload('a50fd8ec', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a50fd8ec&scoped=true&", function () {
      api.rerender('a50fd8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O0CCoyP4zXFA/JS/comp/PopupBox.vue"
export default component.exports